// DATA
export const GET_DATA = 'GET_DATA';
export const GET_LIST = 'GET_LIST';
export const GET_LISTING_AMOUNT = 'GET_LISTING_AMOUNT';
export const SHOW_SEARCH_BTN = 'SHOW_SEARCH_BTN';

// MESSAGE
export const CREATE_MESSAGE = 'CREATE_MESSAGE';
export const GET_ERRORS = 'GET_ERRORS';